<ion-content>
     <ion-row>
         <ion-col col-12>
             <ion-segment scrollable [(ngModel)]="selectedSegmentButton" (ionChange)="selectedSegmentChange($event)">
                 <ion-segment-button value="massenstart">
                     Massenstart
                 </ion-segment-button>
                 <ion-segment-button value="einzelstart">
                     Einzelstart
                 </ion-segment-button>
                 <ion-segment-button value="wellenstart1">
                     Wellenstart1
                 </ion-segment-button>
                 <ion-segment-button value="wellenstart2">
                     Wellenstart2
                 </ion-segment-button>
                 <ion-segment-button value="wellenstart3">
                     Wellenstart3
                 </ion-segment-button>
                 <ion-segment-button value="wellenstart4">
                     Wellenstart4
                 </ion-segment-button>
                 <ion-segment-button value="wellenstart5">
                     Wellenstart5
                 </ion-segment-button>
                 <ion-segment-button value="wellenstart6">
                     Wellenstart6
                 </ion-segment-button>
                 <ion-segment-button value="wellenstart7">
                     Wellenstart7
                 </ion-segment-button>
                 <ion-segment-button value="wellenstart8">
                     Wellenstart8
                 </ion-segment-button>
                 <ion-segment-button value="wellenstart9">
                     Wellenstart9
                 </ion-segment-button>
             </ion-segment>
         </ion-col>
     </ion-row>
     <ng-container [ngSwitch]="selectedSegmentButton">
         <ion-list *ngSwitchCase="'massenstart'">
             <ion-row class="time-row">
                 <ion-col text-center style="padding-top: 0;">
                     <strong [style.color]="color">
                         <p class="font-size-verylarge">{{ displayMassenTimer()}}</p>
                     </strong>
                 </ion-col>
             </ion-row>
             <ion-row class="track-buttons-container">
                 <div class="track-buttons">
                     <ion-col>
                         <button ion-button icon-only clear (click)="openScoreBoard()">
                             <ion-icon name="list"></ion-icon>
                         </button>
                     </ion-col>
                     <ion-col>
                         <button *ngIf="!massenTimerRuns" [style.backgroundColor]="color" ion-button
                              icon-only clear 
                             (click)="startMassenTimer()">
                             <ion-icon name="play" [style.color]="bgColor" class="font-medium center-triangle">
                             </ion-icon>
                         </button>
                         <button *ngIf="massenTimerRuns" [style.backgroundColor]="color" ion-button
                             class="round scale-big colored round-big" icon-only clear (click)="pauseMassenTimer()">
                             <ion-icon name="pause" [style.color]="bgColor" class="font-medium"></ion-icon>
                         </button>
                     </ion-col>
                     <ion-col>
                         <button ion-button icon-only clear (click)="restartMassenTimer()">
                             <ion-icon [style.color]="colorIcon" name="ios-refresh-circle-outline">
                             </ion-icon>
                         </button>
                     </ion-col>
                 </div>
             </ion-row>
             <div class="cards-container">
                 <ion-row class="cards">
                     <div *ngFor="let athlete of massenstartAthletesArray" 
                     [ngClass]="{'card-massenstart-white': (athlete.isPaused && !athlete.isStoped) || (!athlete.isPaused && athlete.isStoped) || (athlete.isPaused && athlete.isStoped),
                                'card-massenstart-blue': (!athlete.isPaused && !athlete.isStoped)}" 
                      (click)="userTap(athlete)">
                         <h1 class="card-name">{{athlete.firstName}}</h1>
                         <h2 class="card-bibnumber">{{athlete.bibNo}}</h2>
                         <!-- <h2 class="card-duration">{{athlete.duration}}</h2> -->
                         <h2 *ngIf="(!athlete.isPaused && !athlete.isStoped) || (athlete.isPaused && !athlete.isStoped) && (massenTimerRunned)" class="card-duration">{{displayMassenTimer()}}</h2>
                         <!-- <h2 *ngIf="athlete.isPaused && !athlete.isStoped" class="card-duration">{{displayMassenTimer()}}</h2> -->
                         <h2 *ngIf="athlete.isStoped" class="card-duration">{{athlete.duration}}</h2>
                     </div>
                 </ion-row>
             </div>
         </ion-list>
         <ion-list *ngSwitchCase="'einzelstart'">
             <div class="cards-container">
                <ion-col class="restartbutton">
                    <button ion-button icon-only clear (click)="openScoreBoardEinzelstart()">
                        <ion-icon name="list"></ion-icon>
                    </button>
                    <button ion-button icon-only clear (click)="restartEinzelTimers()">
                        <ion-icon [style.color]="colorIcon" name="ios-refresh-circle-outline">
                        </ion-icon>
                    </button>
                </ion-col>
                 <ion-row class="cards">
                     <div [ngClass]="{'card-massenstart-white': ath.active == false && ath.isPaused == true, 
                                    'card-massenstart-blue': ath.active == true && ath.isPaused == false}" 
                     (press)="restartEinzel(ath)" *ngFor="let ath of einelstartAthletesArray" (click)="onUserClick(ath)">
                         <h1 class="card-name">{{ath.firstName}}</h1>
                         <h2 class="card-bibnumber">{{ath.bibNo}}</h2>
                         <!-- <p class="font-size-verylarge">{{displayAthleteTimer(ath) | date :"HH:mm:ss":'UTC'}}</p> -->
                         <p *ngIf="ath.einzelTimerRunned" class="font-size-verylarge">{{displayEinzelTimer(ath)}}</p>
                     </div>
                 </ion-row>
             </div>
         </ion-list>
         <ion-list *ngSwitchCase="'wellenstart1'">
             <ion-row class="time-row">
                 <ion-col text-center style="padding-top: 0;">
                     <strong [style.color]="color">
                         <p class="font-size-verylarge">{{ displayWaveTimer()}}</p>
                     </strong>
                 </ion-col>
             </ion-row>
             <ion-row class="track-buttons-container">
                 <div class="track-buttons">
                     <ion-col>
                         <button ion-button icon-only clear (click)="openScoreBoardWallen(athletesArray)">
                             <ion-icon name="list"></ion-icon>
                         </button>
                     </ion-col>
                     <ion-col>
                         <button *ngIf="!getWaveStartedValue()" [style.backgroundColor]="color" ion-button
                              icon-only clear [disabled]="isPlayButtonDisabled(athletesArray, selectedSegmentButton)"
                             (click)="startWaveTimer()">
                             <ion-icon name="play" [style.color]="bgColor" class="font-medium center-triangle">
                             </ion-icon>
                         </button>
                         <button *ngIf="getWaveStartedValue()" [style.backgroundColor]="color" ion-button
                             class="round scale-big colored round-big" icon-only clear (click)="pauseWaveTimer()">
                             <ion-icon name="pause" [style.color]="bgColor" class="font-medium"></ion-icon>
                         </button>
                     </ion-col>
                     <ion-col>
                         <button ion-button icon-only clear (click)="restartWaveTimer()">
                             <ion-icon [style.color]="colorIcon" name="ios-refresh-circle-outline">
                             </ion-icon>
                         </button>
                     </ion-col>
                 </div>
             </ion-row>
             <div class="cards-container">
                 <ion-row class="cards">
                     <div *ngFor="let athlete of athletesArray" 
                     [ngClass]="{'card-massenstart-white': (!athlete.isSelected && !athlete.isTimerStarted) || 
                                                            (athlete.isSelected && athlete.isPaused && athlete.isTimerStarted) || 
                                                            (athlete.isSelected && athlete.isPausedTap && athlete.isTimerStarted ), 
                                 'card-massenstart-blue': (athlete.isSelected && athlete.groupId == selectedSegmentButton && !athlete.isPausedTap) ||
                                                        (athlete.isSelected && athlete.groupId == selectedSegmentButton), 
                                 'card-wellenstart-gray': athlete.isSelected && athlete.groupId !== selectedSegmentButton}" 
                                 (click)="userClickWallen(athlete)">
                         <h1 class="card-name">{{athlete.firstName}}</h1>
                         <h2 class="card-bibnumber">{{athlete.bibNo}}</h2>
                         <h2 *ngIf="athlete.isTimerStarted && !athlete.isPausedTap">{{athlete.totalTime}}</h2>
                         <h2 *ngIf="athlete.isPausedTap && athlete.isTimerStarted">{{athlete.duration}}</h2>
                     </div>
                 </ion-row>
             </div>
         </ion-list>
         <ion-list *ngSwitchCase="'wellenstart2'">
             <ion-row class="time-row">
                 <ion-col text-center style="padding-top: 0;">
                     <strong [style.color]="color">
                         <p class="font-size-verylarge">{{ displayWaveTimer()}}</p>
                     </strong>
                 </ion-col>
             </ion-row>
             <ion-row class="track-buttons-container">
                 <div class="track-buttons">
                     <ion-col>
                         <button ion-button icon-only clear (click)="openScoreBoardWallen(athletesArray)">
                             <ion-icon name="list"></ion-icon>
                         </button>
                     </ion-col>
                     <ion-col>
                         <button *ngIf="!getWaveStartedValue()" [style.backgroundColor]="color" ion-button
                              icon-only clear [disabled]="isPlayButtonDisabled(athletesArray, selectedSegmentButton)"
                             (click)="startWaveTimer()">
                             <ion-icon name="play" [style.color]="bgColor" class="font-medium center-triangle">
                             </ion-icon>
                         </button>
                         <button *ngIf="getWaveStartedValue()" [style.backgroundColor]="color" ion-button
                             class="round scale-big colored round-big" icon-only clear (click)="pauseWaveTimer()">
                             <ion-icon name="pause" [style.color]="bgColor" class="font-medium"></ion-icon>
                         </button>
                     </ion-col>
                     <ion-col>
                         <button ion-button icon-only clear (click)="restartWaveTimer(selectedAthlete, athletesArray, selectedSegmentButton)">
                             <ion-icon [style.color]="colorIcon" name="ios-refresh-circle-outline">
                             </ion-icon>
                         </button>
                     </ion-col>
                 </div>
             </ion-row>
             <div class="cards-container">
                 <ion-row class="cards">
                    <div *ngFor="let athlete of athletesArray" 
                     [ngClass]="{'card-massenstart-white': (!athlete.isSelected && !athlete.isTimerStarted) || 
                                                            (athlete.isSelected && athlete.isPaused && athlete.isTimerStarted) || 
                                                            (athlete.isSelected && athlete.isPausedTap && athlete.isTimerStarted ), 
                                 'card-massenstart-blue': (athlete.isSelected && athlete.groupId == selectedSegmentButton && !athlete.isPausedTap) ||
                                                        (athlete.isSelected && athlete.groupId == selectedSegmentButton), 
                                 'card-wellenstart-gray': athlete.isSelected && athlete.groupId !== selectedSegmentButton}" 
                                 (click)="userClickWallen(athlete)">
                         <h1 class="card-name">{{athlete.firstName}}</h1>
                         <h2 class="card-bibnumber">{{athlete.bibNo}}</h2>
                         <h2 *ngIf="athlete.isTimerStarted && !athlete.isPausedTap">{{athlete.totalTime}}</h2>
                         <h2 *ngIf="athlete.isPausedTap && athlete.isTimerStarted">{{athlete.duration}}</h2>
                     </div>
                 </ion-row>
             </div>
         </ion-list>
         <ion-list *ngSwitchCase="'wellenstart3'">
             <ion-row class="time-row">
                 <ion-col text-center style="padding-top: 0;">
                     <strong [style.color]="color">
                         <p class="font-size-verylarge">{{ displayWaveTimer()}}</p>
                     </strong>
                 </ion-col>
             </ion-row>
             <ion-row class="track-buttons-container">
                 <div class="track-buttons">
                     <ion-col>
                         <button ion-button icon-only clear (click)="openScoreBoardWallen(athletesArray)">
                             <ion-icon name="list"></ion-icon>
                         </button>
                     </ion-col>
                     <ion-col>
                         <button *ngIf="!getWaveStartedValue()" [style.backgroundColor]="color" ion-button
                              icon-only clear [disabled]="isPlayButtonDisabled(athletesArray, selectedSegmentButton)"
                             (click)="startWaveTimer()">
                             <ion-icon name="play" [style.color]="bgColor" class="font-medium center-triangle">
                             </ion-icon>
                         </button>
                         <button *ngIf="getWaveStartedValue()" [style.backgroundColor]="color" ion-button
                             class="round scale-big colored round-big" icon-only clear (click)="pauseWaveTimer()">
                             <ion-icon name="pause" [style.color]="bgColor" class="font-medium"></ion-icon>
                         </button>
                     </ion-col>
                     <ion-col>
                         <button ion-button icon-only clear (click)="restartWaveTimer()">
                             <ion-icon [style.color]="colorIcon" name="ios-refresh-circle-outline">
                             </ion-icon>
                         </button>
                     </ion-col>
                 </div>
             </ion-row>
             <div class="cards-container">
                 <ion-row class="cards">
                    <div *ngFor="let athlete of athletesArray" 
                     [ngClass]="{'card-massenstart-white': (!athlete.isSelected && !athlete.isTimerStarted) || 
                                                            (athlete.isSelected && athlete.isPaused && athlete.isTimerStarted) || 
                                                            (athlete.isSelected && athlete.isPausedTap && athlete.isTimerStarted ), 
                                 'card-massenstart-blue': (athlete.isSelected && athlete.groupId == selectedSegmentButton && !athlete.isPausedTap) ||
                                                        (athlete.isSelected && athlete.groupId == selectedSegmentButton), 
                                 'card-wellenstart-gray': athlete.isSelected && athlete.groupId !== selectedSegmentButton}" 
                                 (click)="userClickWallen(athlete)">
                         <h1 class="card-name">{{athlete.firstName}}</h1>
                         <h2 class="card-bibnumber">{{athlete.bibNo}}</h2>
                         <h2 *ngIf="athlete.isTimerStarted && !athlete.isPausedTap">{{athlete.totalTime}}</h2>
                         <h2 *ngIf="athlete.isPausedTap && athlete.isTimerStarted">{{athlete.duration}}</h2>
                     </div>
                 </ion-row>
             </div>
         </ion-list>
         <ion-list *ngSwitchCase="'wellenstart4'">
             <ion-row class="time-row">
                 <ion-col text-center style="padding-top: 0;">
                     <strong [style.color]="color">
                         <p class="font-size-verylarge">{{ displayWaveTimer()}}</p>
                     </strong>
                 </ion-col>
             </ion-row>
             <ion-row class="track-buttons-container">
                 <div class="track-buttons">
                     <ion-col>
                         <button ion-button icon-only clear (click)="openScoreBoardWallen(athletesArray)">
                             <ion-icon name="list"></ion-icon>
                         </button>
                     </ion-col>
                     <ion-col>
                         <button *ngIf="!getWaveStartedValue()" [style.backgroundColor]="color" ion-button
                              icon-only clear [disabled]="isPlayButtonDisabled(athletesArray, selectedSegmentButton)"
                             (click)="startWaveTimer( )">
                             <ion-icon name="play" [style.color]="bgColor" class="font-medium center-triangle">
                             </ion-icon>
                         </button>
                         <button *ngIf="getWaveStartedValue()" [style.backgroundColor]="color" ion-button
                             class="round scale-big colored round-big" icon-only clear (click)="pauseWaveTimer( )">
                             <ion-icon name="pause" [style.color]="bgColor" class="font-medium"></ion-icon>
                         </button>
                     </ion-col>
                     <ion-col>
                         <button ion-button icon-only clear (click)="restartWaveTimer()">
                             <ion-icon [style.color]="colorIcon" name="ios-refresh-circle-outline">
                             </ion-icon>
                         </button>
                     </ion-col>
                 </div>
             </ion-row>
             <div class="cards-container">
                 <ion-row class="cards">
                    <div *ngFor="let athlete of athletesArray" 
                    [ngClass]="{'card-massenstart-white': (!athlete.isSelected && !athlete.isTimerStarted) || 
                                                           (athlete.isSelected && athlete.isPaused && athlete.isTimerStarted) || 
                                                           (athlete.isSelected && athlete.isPausedTap && athlete.isTimerStarted ), 
                                'card-massenstart-blue': (athlete.isSelected && athlete.groupId == selectedSegmentButton && !athlete.isPausedTap) ||
                                                       (athlete.isSelected && athlete.groupId == selectedSegmentButton), 
                                'card-wellenstart-gray': athlete.isSelected && athlete.groupId !== selectedSegmentButton}" 
                                (click)="userClickWallen(athlete)">
                        <h1 class="card-name">{{athlete.firstName}}</h1>
                        <h2 class="card-bibnumber">{{athlete.bibNo}}</h2>
                        <h2 *ngIf="athlete.isTimerStarted && !athlete.isPausedTap">{{athlete.totalTime}}</h2>
                        <h2 *ngIf="athlete.isPausedTap && athlete.isTimerStarted">{{athlete.duration}}</h2>
                    </div>
                 </ion-row>
             </div>
         </ion-list>
         <ion-list *ngSwitchCase="'wellenstart5'">
             <ion-row class="time-row">
                 <ion-col text-center style="padding-top: 0;">
                     <strong [style.color]="color">
                         <p class="font-size-verylarge">{{ displayWaveTimer()}}</p>
                     </strong>
                 </ion-col>
             </ion-row>
             <ion-row class="track-buttons-container">
                 <div class="track-buttons">
                     <ion-col>
                         <button ion-button icon-only clear (click)="openScoreBoardWallen(athletesArray)">
                             <ion-icon name="list"></ion-icon>
                         </button>
                     </ion-col>
                     <ion-col>
                         <button *ngIf="!getWaveStartedValue()" [style.backgroundColor]="color" ion-button
                              icon-only clear [disabled]="isPlayButtonDisabled(athletesArray, selectedSegmentButton)"
                             (click)="startWaveTimer( )">
                             <ion-icon name="play" [style.color]="bgColor" class="font-medium center-triangle">
                             </ion-icon>
                         </button>
                         <button *ngIf="getWaveStartedValue()" [style.backgroundColor]="color" ion-button
                             class="round scale-big colored round-big" icon-only clear (click)="pauseWaveTimer()">
                             <ion-icon name="pause" [style.color]="bgColor" class="font-medium"></ion-icon>
                         </button>
                     </ion-col>
                     <ion-col>
                         <button ion-button icon-only clear (click)="restartWaveTimer()">
                             <ion-icon [style.color]="colorIcon" name="ios-refresh-circle-outline">
                             </ion-icon>
                         </button>
                     </ion-col>
                 </div>
             </ion-row>
             <div class="cards-container">
                 <ion-row class="cards">
                    <div *ngFor="let athlete of athletesArray" 
                    [ngClass]="{'card-massenstart-white': (!athlete.isSelected && !athlete.isTimerStarted) || 
                                                           (athlete.isSelected && athlete.isPaused && athlete.isTimerStarted) || 
                                                           (athlete.isSelected && athlete.isPausedTap && athlete.isTimerStarted ), 
                                'card-massenstart-blue': (athlete.isSelected && athlete.groupId == selectedSegmentButton && !athlete.isPausedTap) ||
                                                       (athlete.isSelected && athlete.groupId == selectedSegmentButton), 
                                'card-wellenstart-gray': athlete.isSelected && athlete.groupId !== selectedSegmentButton}" 
                                (click)="userClickWallen(athlete)">
                        <h1 class="card-name">{{athlete.firstName}}</h1>
                        <h2 class="card-bibnumber">{{athlete.bibNo}}</h2>
                        <h2 *ngIf="athlete.isTimerStarted && !athlete.isPausedTap">{{athlete.totalTime}}</h2>
                        <h2 *ngIf="athlete.isPausedTap && athlete.isTimerStarted">{{athlete.duration}}</h2>
                    </div>
                 </ion-row>
             </div>
         </ion-list>
         <ion-list *ngSwitchCase="'wellenstart6'">
             <ion-row class="time-row">
                 <ion-col text-center style="padding-top: 0;">
                     <strong [style.color]="color">
                         <p class="font-size-verylarge">{{ displayWaveTimer()}}</p>
                     </strong>
                 </ion-col>
             </ion-row>
             <ion-row class="track-buttons-container">
                 <div class="track-buttons">
                     <ion-col>
                         <button ion-button icon-only clear (click)="openScoreBoardWallen(athletesArray)">
                             <ion-icon name="list"></ion-icon>
                         </button>
                     </ion-col>
                     <ion-col>
                         <button *ngIf="!getWaveStartedValue()" [style.backgroundColor]="color" ion-button
                              icon-only clear [disabled]="isPlayButtonDisabled(athletesArray, selectedSegmentButton)"
                             (click)="startWaveTimer()">
                             <ion-icon name="play" [style.color]="bgColor" class="font-medium center-triangle">
                             </ion-icon>
                         </button>
                         <button *ngIf="getWaveStartedValue()" [style.backgroundColor]="color" ion-button
                             class="round scale-big colored round-big" icon-only clear (click)="pauseWaveTimer()">
                             <ion-icon name="pause" [style.color]="bgColor" class="font-medium"></ion-icon>
                         </button>
                     </ion-col>
                     <ion-col>
                         <button ion-button icon-only clear (click)="restartWaveTimer()">
                             <ion-icon [style.color]="colorIcon" name="ios-refresh-circle-outline">
                             </ion-icon>
                         </button>
                     </ion-col>
                 </div>
             </ion-row>
             <div class="cards-container">
                 <ion-row class="cards">
                    <div *ngFor="let athlete of athletesArray" 
                    [ngClass]="{'card-massenstart-white': (!athlete.isSelected && !athlete.isTimerStarted) || 
                                                           (athlete.isSelected && athlete.isPaused && athlete.isTimerStarted) || 
                                                           (athlete.isSelected && athlete.isPausedTap && athlete.isTimerStarted ), 
                                'card-massenstart-blue': (athlete.isSelected && athlete.groupId == selectedSegmentButton && !athlete.isPausedTap) ||
                                                       (athlete.isSelected && athlete.groupId == selectedSegmentButton), 
                                'card-wellenstart-gray': athlete.isSelected && athlete.groupId !== selectedSegmentButton}" 
                                (click)="userClickWallen(athlete)">
                        <h1 class="card-name">{{athlete.firstName}}</h1>
                        <h2 class="card-bibnumber">{{athlete.bibNo}}</h2>
                        <h2 *ngIf="athlete.isTimerStarted && !athlete.isPausedTap">{{athlete.totalTime}}</h2>
                        <h2 *ngIf="athlete.isPausedTap && athlete.isTimerStarted">{{athlete.duration}}</h2>
                    </div>
                 </ion-row>
             </div>
         </ion-list>
         <ion-list *ngSwitchCase="'wellenstart7'">
             <ion-row class="time-row">
                 <ion-col text-center style="padding-top: 0;">
                     <strong [style.color]="color">
                         <p class="font-size-verylarge">{{ displayWaveTimer()}}</p>
                     </strong>
                 </ion-col>
             </ion-row>
             <ion-row class="track-buttons-container">
                 <div class="track-buttons">
                     <ion-col>
                         <button ion-button icon-only clear (click)="openScoreBoardWallen(athletesArray)">
                             <ion-icon name="list"></ion-icon>
                         </button>
                     </ion-col>
                     <ion-col>
                         <button *ngIf="!getWaveStartedValue()" [style.backgroundColor]="color" ion-button
                              icon-only clear [disabled]="isPlayButtonDisabled(athletesArray, selectedSegmentButton)"
                             (click)="startWaveTimer()">
                             <ion-icon name="play" [style.color]="bgColor" class="font-medium center-triangle">
                             </ion-icon>
                         </button>
                         <button *ngIf="getWaveStartedValue()" [style.backgroundColor]="color" ion-button
                             class="round scale-big colored round-big" icon-only clear (click)="pauseWaveTimer()">
                             <ion-icon name="pause" [style.color]="bgColor" class="font-medium"></ion-icon>
                         </button>
                     </ion-col>
                     <ion-col>
                         <button ion-button icon-only clear (click)="restartWaveTimer()">
                             <ion-icon [style.color]="colorIcon" name="ios-refresh-circle-outline">
                             </ion-icon>
                         </button>
                     </ion-col>
                 </div>
             </ion-row>
             <div class="cards-container">
                 <ion-row class="cards">
                    <div *ngFor="let athlete of athletesArray" 
                    [ngClass]="{'card-massenstart-white': (!athlete.isSelected && !athlete.isTimerStarted) || 
                                                           (athlete.isSelected && athlete.isPaused && athlete.isTimerStarted) || 
                                                           (athlete.isSelected && athlete.isPausedTap && athlete.isTimerStarted ), 
                                'card-massenstart-blue': (athlete.isSelected && athlete.groupId == selectedSegmentButton && !athlete.isPausedTap) ||
                                                       (athlete.isSelected && athlete.groupId == selectedSegmentButton), 
                                'card-wellenstart-gray': athlete.isSelected && athlete.groupId !== selectedSegmentButton}" 
                                (click)="userClickWallen(athlete)">
                        <h1 class="card-name">{{athlete.firstName}}</h1>
                        <h2 class="card-bibnumber">{{athlete.bibNo}}</h2>
                        <h2 *ngIf="athlete.isTimerStarted && !athlete.isPausedTap">{{athlete.totalTime}}</h2>
                        <h2 *ngIf="athlete.isPausedTap && athlete.isTimerStarted">{{athlete.duration}}</h2>
                    </div>
                 </ion-row>
             </div>
         </ion-list>
         <ion-list *ngSwitchCase="'wellenstart8'">
             <ion-row class="time-row">
                 <ion-col text-center style="padding-top: 0;">
                     <strong [style.color]="color">
                         <p class="font-size-verylarge">{{ displayWaveTimer()}}</p>
                     </strong>
                 </ion-col>
             </ion-row>
             <ion-row class="track-buttons-container">
                 <div class="track-buttons">
                     <ion-col>
                         <button ion-button icon-only clear (click)="openScoreBoardWallen(athletesArray)">
                             <ion-icon name="list"></ion-icon>
                         </button>
                     </ion-col>
                     <ion-col>
                         <button *ngIf="!getWaveStartedValue()" [style.backgroundColor]="color" ion-button
                              icon-only clear [disabled]="isPlayButtonDisabled(athletesArray, selectedSegmentButton)"
                             (click)="startWaveTimer( )">
                             <ion-icon name="play" [style.color]="bgColor" class="font-medium center-triangle">
                             </ion-icon>
                         </button>
                         <button *ngIf="getWaveStartedValue()" [style.backgroundColor]="color" ion-button
                             class="round scale-big colored round-big" icon-only clear (click)="pauseWaveTimer()">
                             <ion-icon name="pause" [style.color]="bgColor" class="font-medium"></ion-icon>
                         </button>
                     </ion-col>
                     <ion-col>
                         <button ion-button icon-only clear (click)="restartWaveTimer()">
                             <ion-icon [style.color]="colorIcon" name="ios-refresh-circle-outline">
                             </ion-icon>
                         </button>
                     </ion-col>
                 </div>
             </ion-row>
             <div class="cards-container">
                 <ion-row class="cards">
                    <div *ngFor="let athlete of athletesArray" 
                    [ngClass]="{'card-massenstart-white': (!athlete.isSelected && !athlete.isTimerStarted) || 
                                                           (athlete.isSelected && athlete.isPaused && athlete.isTimerStarted) || 
                                                           (athlete.isSelected && athlete.isPausedTap && athlete.isTimerStarted ), 
                                'card-massenstart-blue': (athlete.isSelected && athlete.groupId == selectedSegmentButton && !athlete.isPausedTap) ||
                                                       (athlete.isSelected && athlete.groupId == selectedSegmentButton), 
                                'card-wellenstart-gray': athlete.isSelected && athlete.groupId !== selectedSegmentButton}" 
                                (click)="userClickWallen(athlete)">
                        <h1 class="card-name">{{athlete.firstName}}</h1>
                        <h2 class="card-bibnumber">{{athlete.bibNo}}</h2>
                        <h2 *ngIf="athlete.isTimerStarted && !athlete.isPausedTap">{{athlete.totalTime}}</h2>
                        <h2 *ngIf="athlete.isPausedTap && athlete.isTimerStarted">{{athlete.duration}}</h2>
                    </div>
                 </ion-row>
             </div>
         </ion-list>
         <ion-list *ngSwitchCase="'wellenstart9'">
             <ion-row class="time-row">
                 <ion-col text-center style="padding-top: 0;">
                     <strong [style.color]="color">
                         <p class="font-size-verylarge">{{ displayWaveTimer()}}</p>
                     </strong>
                 </ion-col>
             </ion-row>
             <ion-row class="track-buttons-container">
                 <div class="track-buttons">
                     <ion-col>
                         <button ion-button icon-only clear (click)="openScoreBoardWallen(athletesArray)">
                             <ion-icon name="list"></ion-icon>
                         </button>
                     </ion-col>
                     <ion-col>
                         <button *ngIf="!getWaveStartedValue()" [style.backgroundColor]="color" ion-button
                              icon-only clear [disabled]="isPlayButtonDisabled(athletesArray, selectedSegmentButton)"
                             (click)="startWaveTimer()">
                             <ion-icon name="play" [style.color]="bgColor" class="font-medium center-triangle">
                             </ion-icon>
                         </button>
                         <button *ngIf="getWaveStartedValue()" [style.backgroundColor]="color" ion-button
                             class="round scale-big colored round-big" icon-only clear (click)="pauseWaveTimer()">
                             <ion-icon name="pause" [style.color]="bgColor" class="font-medium"></ion-icon>
                         </button>
                     </ion-col>
                     <ion-col>
                         <button ion-button icon-only clear (click)="restartWaveTimer()">
                             <ion-icon [style.color]="colorIcon" name="ios-refresh-circle-outline">
                             </ion-icon>
                         </button>
                     </ion-col>
                 </div>
             </ion-row>
             <div class="cards-container">
                 <ion-row class="cards">
                    <div *ngFor="let athlete of athletesArray" 
                    [ngClass]="{'card-massenstart-white': (!athlete.isSelected && !athlete.isTimerStarted) || 
                                                           (athlete.isSelected && athlete.isPaused && athlete.isTimerStarted) || 
                                                           (athlete.isSelected && athlete.isPausedTap && athlete.isTimerStarted ), 
                                'card-massenstart-blue': (athlete.isSelected && athlete.groupId == selectedSegmentButton && !athlete.isPausedTap) ||
                                                       (athlete.isSelected && athlete.groupId == selectedSegmentButton), 
                                'card-wellenstart-gray': athlete.isSelected && athlete.groupId !== selectedSegmentButton}" 
                                (click)="userClickWallen(athlete)">
                        <h1 class="card-name">{{athlete.firstName}}</h1>
                        <h2 class="card-bibnumber">{{athlete.bibNo}}</h2>
                        <h2 *ngIf="athlete.isTimerStarted && !athlete.isPausedTap">{{athlete.totalTime}}</h2>
                        <h2 *ngIf="athlete.isPausedTap && athlete.isTimerStarted">{{athlete.duration}}</h2>
                    </div>
                 </ion-row>
             </div>
         </ion-list>
       </ng-container>
     </ion-content>